import type { TransactionalLogActor } from './types'

let currentActor: TransactionalLogActor | null = null

export function setTransactionalLogActor(
  actor: TransactionalLogActor | null
): void {
  currentActor = actor
}

export function getTransactionalLogActor(): TransactionalLogActor | null {
  return currentActor
}
